import { createSlice, PayloadAction } from '@reduxjs/toolkit';

/**
 * State for the Reload Membership Bank flow (`/a/bank`): amount step →
 * payment step → success view. Deliberately not persisted — an abandoned
 * flow restarts at the amount step.
 */
export type BankReloadStore = {
  amount: number;
  isLoading: boolean;
  errorMsg: string;
  confirmationId: number | null;
  isSuccess: boolean;
};

const initialState: BankReloadStore = {
  amount: 0,
  isLoading: false,
  errorMsg: '',
  confirmationId: null,
  isSuccess: false
};

export const bankReloadSlice = createSlice({
  name: 'bankReload',
  initialState,
  reducers: {
    setBankReloadAmount: (state, action: PayloadAction<number>) => {
      state.amount = action.payload;
    },
    setBankReloadLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },
    setBankReloadError: (state, action: PayloadAction<string>) => {
      state.errorMsg = action.payload;
    },
    setBankReloadSuccess: (state, action: PayloadAction<number | null>) => {
      state.isSuccess = true;
      state.confirmationId = action.payload;
      state.errorMsg = '';
    },
    resetBankReload: () => initialState
  }
});

export const {
  setBankReloadAmount,
  setBankReloadLoading,
  setBankReloadError,
  setBankReloadSuccess,
  resetBankReload
} = bankReloadSlice.actions;

export default bankReloadSlice.reducer;
